import { useQuery } from '@tanstack/react-query';
import { getVenue, IGetVenueResponseData } from 'src/api/getVenue';
import { mapVenueToDetailsPage } from 'src/pages/Venue/mapVenueToDetailsPage/mapVenueToDetailsPage';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';

export const useVenue = (venueId: string, pathname?: string) => {
  const { showSnackbar } = useSnackbar();

  return useQuery({
    queryKey: ['venue', venueId, pathname],
    queryFn: async () => {
      try {
        const data: IGetVenueResponseData = await getVenue(venueId);
        const formattedData = mapVenueToDetailsPage(data);
        return formattedData;
      } catch (e) {
        console.error('Error fetching venue:', e);
        showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' });
      }
    },
  });
};
